import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {};
__decorate([Prop({
  default: false
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  default: '气泡容器'
})], default_1.prototype, "title", void 0);
__decorate([Prop({
  default: 'bottom'
})], default_1.prototype, "placement", void 0);
__decorate([Prop({
  default: 'click'
})], default_1.prototype, "trigger", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "disabled", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "showScroll", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "visibleArrow", void 0);
__decorate([Prop(String)], default_1.prototype, "width", void 0);
default_1 = __decorate([Component({
  name: 'AmFePopupContainerMixin'
})], default_1);
export default default_1;